export default __webpack_public_path__ + "static/media/exit.d3dc68c7.svg";